// Touch hit area for table checkbox cells (W-iP7).
//
// A checkbox is ~16px; a finger needs 44px. A pseudo-element on <input type="checkbox"> is not
// rendered by every engine, and a bigger visible box would change the row height, so instead
// the whole cell is the target: on a coarse pointer, a tap anywhere in a `.wrap-touch-check`
// cell that misses the checkbox itself toggles it. Desktop (fine pointer) is untouched.
// Detected with the pointer media feature, never the user agent.

function isCoarsePointer(): boolean {
  try {
    return typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: coarse)').matches;
  } catch {
    return false;
  }
}

export function handleTouchCheckClick(e: MouseEvent): void {
  if (!isCoarsePointer()) return;
  const target = e.target;
  if (!(target instanceof Element)) return;
  // A tap on the checkbox, a label or any other control does its own thing.
  if (target.closest('input,label,button,a,select,textarea')) return;
  const cell = target.closest('.wrap-touch-check');
  if (!cell) return;
  const box = cell.querySelector<HTMLInputElement>('input[type="checkbox"]');
  if (!box || box.disabled) return;
  e.preventDefault();
  e.stopPropagation();
  box.click();
}

let installed = false;

/** Installs the delegated listener once for the app. Returns an uninstall function. */
export function installTouchCheckCells(doc: Document = document): () => void {
  if (installed) return () => {};
  installed = true;
  doc.addEventListener('click', handleTouchCheckClick, true);
  return () => {
    doc.removeEventListener('click', handleTouchCheckClick, true);
    installed = false;
  };
}
